import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { CityModel, HxCityService, HxUiLabelPipe, PagedList } from 'hx-services';
import { HxCountrySelectComponent, HxPagedListDirective } from 'hx-components';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzCollapseComponent, NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { FormsModule } from '@angular/forms';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzThAddOnComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { NgFor } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

interface ListFilter {
  name: string;
  options: { label: string, value: string | number, checked?: boolean }[];
  isVisible: boolean;
  isActive: boolean;
  operator: 'and' | 'or';
}

@Component({
    selector: 'hc-city-list',
    templateUrl: './city-list.component.html',
    styleUrls: ['./city-list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzCollapseComponent, NzCollapsePanelComponent, NzRowDirective, NzColDirective, HxCountrySelectComponent, FormsModule, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzThAddOnComponent, NzTbodyComponent, NgFor, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, HxUiLabelPipe, TranslocoPipe]
})
export class CityListComponent extends HxPagedListDirective<CityModel> implements OnInit {

  filter: {
    countryId?: number;
  } = {};

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    private cityService: HxCityService,
  ) {
    super(router, aRoute);
    this.limit = 20;
  }

  ngOnInit() {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => super.load(paramMap));
  }

  resetFilter(filter: ListFilter) {
    filter.options.forEach(op => op.checked = false);
  }

  applyFilters() {
    this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: {
        countryId: this.filter.countryId,
      }
    });
  }

  protected loadList(): Promise<PagedList<CityModel>> {
    return this.cityService.getCities({
      page: this.page,
      limit: this.limit,
      includeDisabled: true,
      countryId: this.filter.countryId,
      sort: this.getSortParams(),
    });
  }

  remove(id: number): void {
    this.cityService.removeCity(id).subscribe(() => this.loadData());
  }
}
